import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  CreateForecastScenarioRequest,
  ForecastScenario,
  UpdateForecastScenarioRequest,
} from "../models/ForecastScenario";

export const ForecastScenarioApi = {
  create: async (request: CreateForecastScenarioRequest) => {
    return await jwtAuthAxios().post<ForecastScenario>(
      `/forecast-scenarios`,
      request
    );
  },

  update: async (id: string, request: UpdateForecastScenarioRequest) => {
    return await jwtAuthAxios().put<ForecastScenario>(
      `/forecast-scenarios/${id}`,
      request
    );
  },

  delete: async (id: string) => {
    return await jwtAuthAxios().delete(`/forecast-scenarios/${id}`);
  },
};
